import React, { memo } from 'react'
import './index.scss'

const Input = React.forwardRef((props: any, ref) => {
  return (
    <div className='handtop-input-wrap'>
      {
        !!props.icon && <i className={props.icon}></i>
      }
      <input {...props} ref={ref} className={`handtop-input ${props.className || ''} ${props.icon ? 'has-icon' : ''}`} />
    </div>
  )
})

export default memo(Input)
